import {httpAction, getAction, postAction} from '@/api/manage'
//同意
export function agree(applicationCode,that,isNext){
  /*that.initPageData(that.model.business_form_no);
  that.urlType=='todoProcess'
  that.$set(that.model,'comments','')*/
  if(applicationCode === 'env_audit'){
    epm_agree(that,isNext);
  }else if(applicationCode === 'ipsys'){
    ipsys_agree(that,isNext)
  }else{
    other_agree(that,applicationCode,isNext)
  }
}
function getNextFormNo(that,modelGuid,isNext) {
  if(!!isNext&&isNext=='1'){
    let username = that.$store.getters.userInfo.workNo
    getAction("/sys/electronic-signed/unifiedSigned/getFirstTodoFormNo",{username:username,modelGuid:modelGuid}).then(res=>{
      if(res.success){
        let nextFrom = res.result
        if(!!nextFrom){
          that.initPageData(nextFrom);
          that.setEdit = true
          that.urlType=='todoProcess'
          // that.model.comments = ''
          that.$set(that.model,'comments','')
        }else{
          that.setEdit = false
          that.urlType=='flishProcess'
        }
      }
    })
  }
}
function other_agree(that,applicationCode,isNext) {
  let map = {};
  map.applicationCode=applicationCode;
  map.processGuid = that.model.process_guid;
  map.taskCode = that.model.task_code;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.comments = that.model.comments;
  map.approveAction = "Agree";
  map.file = that.model.file;
  that.confirmLoading = true;
  postAction("/sys/electronic-signed/process/"+that.model.business_form_no, map).then((res) => {
    if (res.success) {
      that.setEdit = false;
      that.confirmLoading = false;
      /*if(that.$refs.applicationModel.hasOwnProperty('checkApprovedCallback')){
        that.$refs.applicationModel.checkApprovedCallback()
      }*/
      getNextFormNo(that,that.model.model_guid,isNext);
    } else {
      that.confirmLoading = false;
      that.$message.warning(res.message);
    }
  })
}
function epm_agree(that,isNext) {
  let map = {};
  map.pfBpmProcessId = that.model.process_guid;
  map.comments = that.model.comments;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Agree";
  map.taskCode = that.model.task_code;
  that.confirmLoading = true;
  getAction("/sys/wfapi/pageToRunProcess", map).then((res) => {
    if (res.success) {
      that.setEdit = false;
      that.confirmLoading = false;
      that.agreeBack(that.model.model_guid,isNext);
    }
  })
}
function ipsys_agree(that,isNext) {
  if(that.model.model_code == 'IpsTrademarkUserReport'||that.model.model_code == 'IpsTrademarkUserReportC'){
    /*if(that.model.task_code==='ApproveTask8'){
        if(!that.model.file||(that.model.file&&that.model.file.pfBpmFileDetailList.length===0)){
          // that.$message.warning("请在附档中上传附件再送出！");
          that.$message.warning(that.language['eletronicSigned.fileUrlsWarn'])
          return;
        }
      }*/
    let map = {};
    map.processGuid = that.model.process_guid;
    map.taskCode = that.model.task_code;
    map.approverUserCode = that.$store.getters.userInfo.workNo;
    map.comments = that.model.comments;
    map.approveAction = "Agree";
    map.file = that.model.file;
    that.confirmLoading = true;
    postAction("/sys/electronicSigned/ipsysProcess/"+that.model.process_guid, map).then((res) => {
      if (res.success) {
        that.setEdit = false;
        that.confirmLoading = false;
        that.agreeBack(that.model.model_guid,isNext);
      }
    })
  }else{
    other_agree(that,"ipsys",isNext)
  }

}